import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/index'
import { baseApi } from '@/api/baseApi'
Vue.use(Router)

let originPush = Router.prototype.push
let originReplace = Router.prototype.replace

Router.prototype.push = function (location, resolve, reject) {
  if (resolve && reject) {
    originPush.call(this, location, resolve, reject)
  } else {
    originPush.call(
      this,
      location,
      () => {},
      () => {}
    )
  }
}

Router.prototype.replace = function (location, resolve, reject) {
  if (resolve && reject) {
    originReplace.call(this, location, resolve, reject)
  } else {
    originReplace.call(
      this,
      location,
      () => {},
      () => {}
    )
  }
}

let router = new Router({
  mode: 'history',
  // mode: 'hash',
  routes: [
    // 默认进入首页
    {
      path: '/',
      redirect: '/businessAll',
    },
    {
      path: '/main',
      name: 'main',
      component: () => import('@/views/main/index'),
      children: [
        {
          // 询盘商机
          path: '/businessAll',
          name: 'businessAll',
          component: () => import('@/views/business/businessAll'),
          meta: { keepAlive: true, title: '询盘商机', pageIndex: 1 },
        },
        {
          // 会员中心
          path: '/vip',
          name: 'vip',
          component: () => import('@/views/vip/index'),
          meta: { title: '会员中心', pageIndex: 2 },
        },
        {
          // 我的商机
          path: '/myBusiness',
          name: 'myBusiness',
          component: () => import('@/views/business/myBusiness'),
          meta: { keepAlive: true, title: '我的商机', pageIndex: 3 },
        },
        {
          // 成交案例
          path: '/marketCases',
          name: 'marketCases',
          component: () => import('@/views/marketCases/index'),
          meta: { title: '成交案例' },
        },
        {
          // 定制商机
          path: '/customized',
          name: 'customized',
          component: () => import('@/views/customized/index'),
          meta: { title: '定制商机' },
        },
        {
          // 设置提醒时段及区域
          path: '/setReminder',
          name: 'setReminder',
          component: () => import('@/views/setReminder/index'),
          meta: { title: '设置提醒时段及区域' },
        },
        {
          // 设置个人资料
          path: '/accountInfo',
          name: 'accountInfo',
          component: () => import('@/views/accountInfo/index'),
          meta: { title: '设置个人资料' },
        },
        {
          // 账户明细
          path: '/amonut',
          name: 'amonut',
          component: () => import('@/views/amonut/index'),
          meta: { title: '账户明细' },
        },
        {
          // 积分明细
          path: '/pointList',
          name: 'pointList',
          component: () => import('@/views/point/pointList'),
          meta: { title: '积分明细' },
        },
        {
          // 我的申诉退款
          path: '/refund',
          name: 'refund',
          component: () => import('@/views/refund/index'),
          meta: { title: '我的申诉退款' },
        },
        {
          // 已购买的服务
          path: '/existingServices',
          name: 'existingServices',
          component: () => import('@/views/existingServices/index'),
          meta: { title: '已购买的服务' },
        },
        {
          // 金牌会员服务
          path: '/vipList',
          name: 'vipList',
          component: () => import('@/views/vip/vipList'),
          meta: { title: '金牌会员服务' },
        },
        {
          // 意见反馈
          path: '/opinion',
          name: 'opinion',
          component: () => import('@/views/opinion/index'),
          meta: { title: '意见反馈' },
        },
        {
          // 关于我们
          path: '/aboutUs',
          name: 'aboutUs',
          component: () => import('@/views/aboutUs/index'),
          meta: { title: '关于我们' },
        },
        {
          // 商机详情
          path: '/businessDetail',
          name: 'businessDetail',
          component: () => import('@/views/business/businessDetail'),
          meta: { title: '商机详情' },
        },
        {
          // 成交案例-详情
          path: '/marketCasesDetail',
          name: 'marketCasesDetail',
          component: () => import('@/views/marketCases/marketCasesDetail'),
          meta: { title: '成交案例' },
        },
        {
          // 申诉
          path: '/appeal',
          name: 'appeal',
          component: () => import('@/views/refund/appeal'),
          meta: { title: '申诉' },
        },
        {
          // 申诉详情
          path: '/appealDetail',
          name: 'appealDetail',
          component: () => import('@/views/refund/appealDetail'),
          meta: { title: '申诉详情' },
        },

        {
          // 发布新商机
          path: '/addBusiness',
          name: 'addBusiness',
          component: () => import('@/views/business/addBusiness'),
          meta: { title: '发布新商机', pageIndex: 4 },
        },
        {
          // 我发布的商机
          path: '/addBusinessList',
          name: 'addBusinessList',
          component: () => import('@/views/business/addBusinessList'),
          meta: { title: '我发布的商机' },
        },
        {
          // 积分提现列表
          path: '/point',
          name: 'point',
          component: () => import('@/views/point/index'),
          meta: { title: '积分提现' },
        },
        {
          // 下级用户
          path: '/lowlUserList',
          name: 'lowlUserList',
          component: () => import('@/views/lowlUserList/index'),
          meta: { title: '我的团队' },
        },
        {
          // 积分详情
          path: '/pointDetail',
          name: 'pointDetail',
          component: () => import('@/views/point/pointDetail'),
          meta: { title: '积分详情' },
        },
        {
          // 余额详情
          path: '/amonutDetail',
          name: 'amonutDetail',
          component: () => import('@/views/amonut/amonutDetail'),
          meta: { title: '余额详情' },
        },
        {
          // 分享
          path: '/share',
          name: 'share',
          component: () => import('@/views/share/index'),
          meta: { title: '分享' },
        },
      ],
    },
    {
      path: '/isForbidden',
      name: 'isForbidden',
      component: () => import('@/views/isForbidden/index'),
      meta: { title: '账号已被禁用' },
    },
    {
      path: '/AITips',
      name: 'AITips',
      component: () => import('@/otherViews/AITips'),
    }
  ],
})

router.beforeEach((to, from, next) => {
  if(from.path === '/isForbidden'){
    return
  }
  // wx.config ios保存首次进入地址
  if (!store.state.accountInfo.realAuthUrl) {
    store.commit('accountInfo', { realAuthUrl: location.href })
  }
  // 设置全局地址栏添加邀请码
  if (to.query.code) {
  } else {
    if (
      !Object.keys(store.state.accountInfo).length &&
      sessionStorage.getItem('accountInfo')
    ) {
      store.commit(
        'accountInfo',
        JSON.parse(sessionStorage.getItem('accountInfo'))
      )
    }
  }
  store.commit('viewInfo', {
    title: to.meta.title,
    pageIndex: to.meta.pageIndex,
  })

  next()
  
})

export default router
